import { render, staticRenderFns } from "./AdminProjectPost.vue?vue&type=template&id=343bd30c&"
import script from "./AdminProjectPost.vue?vue&type=script&lang=js&"
export * from "./AdminProjectPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports